import axios from 'axios';
import { getAuthHeader } from "../utils/authHelper.js";

const getAllProducts = async (date, route, division, isExpected) => {
  const apiCall = axios.create({
    baseURL:
      process.env.REACT_APP_API_URL +
      `GetDeliveryRouteData?division=${division === null ? 'FL' : division}&date=${date}&route=${route}&isExpectedOnly=${isExpected}`,
      headers: await getAuthHeader()
  });
  const response = await apiCall.get();
  try {
    return response.data;
  } catch (error) {
    return error;
  }
};

const getRouteStatus = async (date, route, division) => {
  const apiCall = axios.create({
    baseURL:
      process.env.REACT_APP_API_URL +
      `GetRTRNSStatus/${division === null ? 'FL' : division}/${date}/${route}`,
    headers: await getAuthHeader()
  });
  const response = await apiCall.get();
  try {
    return response.data;
  } catch (error) {
    return error;
  }
};

const ProductServices = {
  getAllProducts,
  getRouteStatus,
};

export default ProductServices;
